// extracted by mini-css-extract-plugin
export default {"snackbarOffsetSm":"snackbarOffsetSm--VOs1YE2G","snackbarOffsetNone":"snackbarOffsetNone--Gm6dHBB9","snackbarOffsetLg":"snackbarOffsetLg--_S23HnHC"};